    $(document).ready(function () {
        $('.modal-custom .btn-maximize').click(function () {
            $('.modal-custom').toggleClass('maximized');
        });
    });
;
    $(document).ready(function () {
        $('.multicontact-btn .new-btn').click(function () {
            $('.multicontact-btn').toggleClass('active');
        });
    });
;
    $(document).ready(function () {
        $('.format-money').each(function () {
            var num = parseFloat($(this).attr('value'));
            var price = Number.prototype.toFixed.call(parseFloat(num) || 0, 2),
                //replace "." to ","
                price_sep = price.replace(/(\D)/g, ","),
                //add space
                price_sep = price_sep.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
            $(this).text(price_sep);
        });
    });
;
    $(document).ready(function () {
        $('.format-money-int').each(function () {
            function prettify(num) {
                var n = num.toString();
                var separator = " ";
                return n.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + separator);
            }
            var val = $(this).attr("value");
            $(this).text(prettify(val));
        });
    });
;
    $('.mobile-manage-ad-btn').on("click", function () {
        $('.manage-ad-overlay').addClass('show');
        $('.manage-ad-modal').addClass('show');
    });

    $('.manage-ad-overlay').on("click", function () {
        $('.manage-ad-overlay').removeClass('show');
        $('.manage-ad-modal').removeClass('show');
    });

    $('.close-manage-ad').on("click", function () {
        $('.manage-ad-overlay').removeClass('show');
        $('.manage-ad-modal').removeClass('show');
    });
